import axios from 'axios'
import vuetifyToast from 'vuetify-toast'
import i18n from '@/i18n/i18n'
import store from '@/store/store'

export function apiConfig() {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    timeout: 25000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      iso: localStorage.getItem('iso') || window.navigator.language || 'es-ES',
      locale:
        localStorage.getItem('locale') ||
        window.navigator.language.split('-')[0] ||
        'es',
      Authorization: 'Bearer ' + getToken(),
    },
  })
}
export function apiConfigLocal() {
  return axios.create({
    baseURL: 'http://localhost:3001/v1/', // 'https://api.fbase.tv/v1/',
    withCredentials: false,
    timeout: 25000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      iso: localStorage.getItem('iso') || 'es-ES',
      locale: localStorage.getItem('locale') || 'es',
      Authorization: 'Bearer ' + getToken(),
    },
  })
}

export function setApiToken(token) {
  apiAxios.defaults.headers['Authorization'] = `Bearer ${token}`
}

export function setApiIso(iso) {
  apiAxios.defaults.headers['iso'] = iso
  apiAxios.defaults.headers['locale'] = iso ? iso.split('-')[0] : 'es'
}

export function getToken() {
  let result = localStorage.getItem('userToken')
  return result ? result.trim() : ''
}

const apiAxios = apiConfig()

/**
 * Se atrapan todos los errores de las llamadas de axios y se abre un toast informativo del error
 */
apiAxios.interceptors.response.use(
  function (response) {
    // if (process.env.NODE_ENV !== 'production') {
      if (response.data) {
        console.log('Response:', response.request.responseURL, response.data)
      }
    // }
    return response
  },
  function (error) {
    if (process.env.NODE_ENV !== 'production') console.log({ ...error })
    // handle error
    const { config, response } = error

    if (config && response && response.status === 401) {
      if (process.env.NODE_ENV !== 'production') console.log(response.data)

      let data = response.data || {}
      const errorMessage =
        data.message ||
        data.error ||
        i18n.t('error.apiResponses.sessionExpired')

      vuetifyToast.show({
        text: errorMessage,
        color: 'error',
        timeout: 6000,
        icon: 'warning',
      })

      store.dispatch('auth/logout')
    } else if (response) {
      // The request was made and the server responded with a status code hat falls out of the range of 2xx
      if (process.env.NODE_ENV !== 'production') console.log(response.data)

      let data = response.data || {}
      let errorMessage =
        data.error ||
        data.message ||
        i18n.t('error.apiResponses.messageNotDefined')

      vuetifyToast.show({
        text: errorMessage,
        color: 'error',
        timeout: 6000,
        icon: 'warning',
      })
    } else if (error.request) {
      // The request was made but no response was received
      // vuetifyToast.show({
      //   text: i18n.t('error.apiResponses.timeout'),
      //   color: 'error',
      //   timeout: 6000,
      //   icon: 'warning'
      // })
    } else {
      // Something happened in setting up the request that triggered an Error
      if (process.env.NODE_ENV !== 'production') {
        console.log('Error', error.message)
      }
      // vuetifyToast.show({
      //   text: i18n.t('error.apiResponses.messageNotDefined'),
      //   color: 'error',
      //   timeout: 6000,
      //   icon: 'warning'
      // })
    }
    return Promise.reject(error)
  }
)

apiAxios.interceptors.request.use(function (request) {
  // if (process.env.NODE_ENV !== 'production') {
  console.log('Request:', request.method, request.url, request.data || ' ')

  // }
  if (request.data) {
    Object.keys(request.data).forEach((key) => {
      if (request.data[key] === undefined) request.data[key] = ''
    })
  }
  return request
})

export { apiAxios }
